import React from 'react'
import { string, shape } from 'prop-types'

// Libs
import classNames from 'classnames'

/*
 * TODO: Make allowances for only the left image or only the right image to show
 * by themselves, without the need for the other image to be present.
 */

const Credits = props => {
  const creditsClasses = classNames({
    'visible-xs': props.isVisibleXS,
    'hidden-xs': props.isVisibleSM,
    'col-xs-12': props.isVisibleXS,
    'col-sm-4': props.isVisibleSM,
    'col-md-3': props.isVisibleSM,
    'col-lg-2': props.isVisibleSM,
    'mt-4': true,
    'homepage-banner-credits': true
  })
  return (
    <div className={creditsClasses}>
      <p><span>{ props.reviewer }</span>  { props.reviewDate }</p>
    </div>
  )
}

const HomePageBanner = props => {
  const { review, reviewer, reviewDate } = props.reviewData
  return (
    <div className='container-fluid homepage-banner'>
      <div className='row'>
        <div className='col-xs-12 col-sm-8 col-sm-push-2'>
          <p className='homepage-banner-main'>{`"${review}"`}</p>
        </div>
        <Credits isVisibleXS reviewer={reviewer} reviewDate={reviewDate} />
      </div>
      <div className='row'>
        <div className='hidden-xs col-sm-6 col-md-7 col-lg-8 mt-5 homepage-banner-underline' />
        <Credits isVisibleSM reviewer={reviewer} reviewDate={reviewDate} />
      </div>
    </div>
  )
}

HomePageBanner.propTypes = {
  reviewData: shape({
    review: string.isRequired,
    reviewer: string.isRequired,
    reviewDate: string.isRequired,
    imageLeft: string,
    imageRight: string
  }).isRequired
}

export default HomePageBanner
